import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import { LoadingContainer } from '../shared/styled/shared-styled-components';
import LoadingCardAuth0 from '../shared/LoadingCard/LoadingCardAuth0';

export default function LoginFormAuth0() {
  const { loginWithRedirect, isLoading } = useAuth0();

  useEffect(() => {
    if (!isLoading && loginWithRedirect) {
      loginWithRedirect();
    }
  }, [loginWithRedirect, isLoading]);

  return (
    <LoadingContainer>
      <LoadingCardAuth0 />
    </LoadingContainer>
  );
}
